import React from 'react';
import styled from 'styled-components';

interface IProps {
  children: React.ReactNode;
  open: boolean;
  onClose: () => void;
  background?: 'blue';
  height?: string;
  iconSrc?: string;
}
type TProps = IProps;

export default function ModalListAuto({
  children,
  open,
  onClose,
  background,
  iconSrc,
}: TProps) {
  function handleClose(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {
    event.stopPropagation();
    onClose();
  }

  return (
    <Container
      background={background}
      className={open ? 'open' : ''}
      onClick={(e) => {
        handleClose(e);
      }}
    >
      <BgBluredImage />
      <SContainerWrapper>
        {iconSrc && (
          <SDivLogo>
            <img src={iconSrc} alt="" />
          </SDivLogo>
        )}

        <SContainer $iconSrc={iconSrc} onClick={(e) => e.stopPropagation()}>
          {children}
        </SContainer>
      </SContainerWrapper>
    </Container>
  );
}

const SDivLogo = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 10px;
  pointer-events: none;
  user-select: none;
  height: 60px;
  width: 50%;
  position: absolute;
  top: -16px;
  left: 50%;
  z-index: 6;
  transform: translateX(-50%);
  @media screen and (max-height: 415px) {
    height: 40px;
    visibility: hidden;
  }
  @media screen and (max-width: 450px) {
    height: 40px;
    visibility: hidden;
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    object-fit: contain;
  }
`;

const SContainerWrapper = styled.div`
  max-height: 95%;
  height: 65%;
  width: 35%;
  position: relative;

  @media screen and (max-height: 1200px) {
    height: 70%;
  }
  @media screen and (max-height: 900px) {
    height: 80%;
  }
  @media screen and (max-height: 600px) {
    height: 85%;
  }
  @media screen and (max-height: 415px) {
    height: 100%;
  }
  @media screen and (max-width: 1500px) {
    width: 40%;
  }
  @media screen and (max-width: 1400px) {
    width: 45%;
  }
  @media screen and (max-width: 1200px) {
    width: 55%;
  }
  @media screen and (max-width: 900px) {
    width: 60%;
  }
  @media screen and (max-width: 600px) {
    width: 80%;
  }
  @media screen and (max-width: 450px) {
    width: 100%;
  }

  @media screen and (orientation: portrait) {
    border: none;
    border-radius: 0;
    max-height: 100%;
    height: 100%;
    width: 100%;
  }
`;
const SContainer = styled.div<{ $iconSrc?: string }>`
  display: flex;
  border-radius: 24px;
  flex-direction: column;
  border: 3px solid #fff;
  cursor: auto;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  overflow: hidden;

  margin-top: ${({ $iconSrc }) => ($iconSrc ? '20px' : '0')};
  position: relative;

  height: 100%;
  width: 100%;

  @media screen and (max-height: 415px) {
    margin-top: 0;
  }
  @media screen and (max-width: 450px) {
    margin-top: 0;
  }

  @media screen and (orientation: portrait) {
    border: none;
    border-radius: 0;
  }
`;

const Container = styled.div<{
  background?: 'blue' | 'black' | 'transparent';
  padding?: string;
}>`
  align-items: center;
  cursor: pointer;
  background: linear-gradient(
    180deg,
    rgba(0, 202, 191, 0.6) 0%,
    rgba(0, 173, 212, 0.6) 100%
  );
  backdrop-filter: blur(18px);
  display: flex;
  justify-content: center;
  left: 0;
  top: 0;
  position: absolute;
  height: 100%;
  width: 100%;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.5s linear;
  z-index: 5;

  &.open {
    opacity: 1;
    pointer-events: auto;
  }
`;

const BgBluredImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  pointer-events: none;
`;
